import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { API_URL } from "./config";

// Имя автора под материалом → id его страницы-визитки. Запросы со страницы (десятки карточек)
// собираются в один пакет, результаты кэшируются на время сессии.
const cache = new Map();          // имя → id или null (нет страницы)
let queue = new Set();
let waiters = [];
let timer = null;

function flush() {
  const names = Array.from(queue);
  const ws = waiters;
  queue = new Set();
  waiters = [];
  timer = null;
  const finish = map => {
    names.forEach(n => cache.set(n, map[n] ?? null));
    ws.forEach(w => w());
  };
  fetch(`${API_URL}/authors/lookup?names=${encodeURIComponent(names.join("|"))}`)
    .then(r => (r.ok ? r.json() : {}))
    .then(finish)
    .catch(() => finish({}));
}

export function requestAuthor(name, onReady) {
  if (!name || cache.has(name)) return cache.get(name) ?? null;
  queue.add(name);
  waiters.push(onReady);
  if (!timer) timer = setTimeout(flush, 30);
  return undefined;
}

export function useAuthorId(name) {
  const [, setTick] = useState(0);
  useEffect(() => { requestAuthor(name, () => setTick(t => t + 1)); }, [name]);
  return name ? cache.get(name) : null;
}

/** Имя автора: ссылкой на его страницу, если она есть (публичные авторы), иначе простым текстом. */
export function AuthorLink({ name, className, style, children }) {
  const id = useAuthorId(name);
  if (!name) return null;
  const label = children || name;
  return id
    ? <Link to={`/doctors/${id}`} className={className} style={{ textDecoration: "none", ...style }}>{label}</Link>
    : <span className={className} style={style}>{label}</span>;
}
